import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Router from "../../../const/router";
import checkWorkPosition from "../../../helpers/checkWorkPosition";
// Assets
import Arrow from "../../../assets/arrow.png";

const Works = () => {
  const works = useSelector((state) => state.works.data);
  const dispatch = useDispatch();

  // useEffect(() => {
  //   const fillWorks = async () => {
  //     try {
  //       const { data } = await $GET(Router.WORKS);
  //       dispatch(addWorks(data));
  //     } catch (err) {
  //       throw new Error(err.message);
  //     }
  //   };
  //   fillWorks();
  // }, []);

  return (
    <section className="works">
      <div className="section-wrapper">
        <h1 className="section-mention">Works</h1>
        <hr className="section-hr" />
        <div className="row">
          <h1 className="works-title">All Creative Projects</h1>
          <div className="works-explore">
            <Link to={Router.WORKS}>Explore More</Link>
            <img src={Arrow} alt="arrow" />
          </div>
        </div>
        <div className="works-pictures">
          {works ? (
            works.map((item, idx) => {
              const { image_url, _id, deployed_url } = item;
              // const imageUrl = `${SERVER_URL}/${Router.WORKS_UPLOAD}/${image_url}`;
              return (
                <div style={checkWorkPosition(idx + 1)} key={_id}>
                  <a target="_blank" rel="noreferrer" href={deployed_url}>
                    <img src={image_url} alt="work" />
                  </a>
                </div>
              );
            })
          ) : (
            <p>No Work</p>
          )}
        </div>
      </div>
      <div className="bg-filter"></div>
    </section>
  );
};

export default Works;
